import { compose, withHandlers, withState, withProps } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showNewShopTiresModal } from 'components/NewShopTiresModal/actions'
import withType from 'components/common/hoc/withType'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import withTrailerFlags from 'components/common/hoc/withTrailerFlags'
import {
  getCurrentStoreIsE2EAppointment,
  getCurrentStore,
  getCurrentStorePhoneNumber,
  getCurrentStoreEnableAppointmentFlag
} from 'selectors/getCurrentStore'
import { get3StepperEnabled } from 'selectors/thirdPartyData'
import { isDesktop } from 'components/common/Media/helpers'
import { showStoreLocatorModal3StepperEnabled } from 'actions/storeLocator'
import { showAppointmentUnsupportedModal } from 'components/Header/components/MakeAnAppointment/components/AppointmentUnsupportedModal/actions'
import { QUICK_APPOINTMENT_PAGE } from 'constant'
import { INITIAL_HOVER_DATA_REGIONAL_DETAILS, OIL_CHANGE_PRE_SELECTED_QUERY } from './constants'
import { APPOINTMENT_TITLE, MAIN_YMME_SOURCE, SCHEDULE_APPOINTMENT_TITLE } from '../HomePage/MainHeadlineContent/constant'
import BOTRegionalDetails from './BOTRegionalDetails'

const withHoverState = withState('hover', 'setHover', INITIAL_HOVER_DATA_REGIONAL_DETAILS)

const mapStateToProps = (state) => ({
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state),
  myStoreExists: Boolean(getCurrentStore(state)),
  myStorePhoneNumber: getCurrentStorePhoneNumber(state),
  myStoreAppointmentEnableFlag: getCurrentStoreEnableAppointmentFlag(state),
  threeStepperEnabled: get3StepperEnabled(state)
})

const withIsDesktop = withProps(() => ({
  isDesktop: isDesktop()
}))

const withValuePropositionHandlers = withHandlers({
  onMouseEnterHandler: ({ setHover, isDesktop }) => (alt) => {
    isDesktop && setHover({
      ...INITIAL_HOVER_DATA_REGIONAL_DETAILS,
      [alt]: true
    })
  },
  onMouseLeaveHandler: ({ setHover, isDesktop }) => () => {
    isDesktop && setHover(INITIAL_HOVER_DATA_REGIONAL_DETAILS)
  },
  showNewYMMEModal: ({ showNewShopTiresModal, hasActiveVehicle, navigateToTireSearchOrShowYmme, isTrailer }) => () => {
    (hasActiveVehicle && !isTrailer)
      ? navigateToTireSearchOrShowYmme()
      : showNewShopTiresModal({ ymmeName: MAIN_YMME_SOURCE })
  },
  oilChangeClick: ({
    myStoreExists,
    myStorePhoneNumber,
    myStoreAppointmentEnableFlag,
    showAppointmentUnsupportedModal,
    threeStepperEnabled,
    showStoreLocatorModal3StepperEnabled,
    navigateToQuickApptPage,
    history
  }) => e => {
    if (myStoreExists && !myStoreAppointmentEnableFlag) {
      e.preventDefault()
      showAppointmentUnsupportedModal({ phoneNumber: myStorePhoneNumber })
    } else if (!myStoreExists && threeStepperEnabled) {
      e.preventDefault()
      showStoreLocatorModal3StepperEnabled(OIL_CHANGE_PRE_SELECTED_QUERY)
    } else if (navigateToQuickApptPage) {
      history.push(`${QUICK_APPOINTMENT_PAGE}?preSelectedService=${OIL_CHANGE_PRE_SELECTED_QUERY}`)
    }
  }
})


const withConfigureHandleShopByVehicleClick = withProps(({ onClick, showNewYMMEModal, isE2EAppointment }) => ({
  handleShopByVehicleClick: onClick || showNewYMMEModal,
  appointmentTitle: isE2EAppointment ? SCHEDULE_APPOINTMENT_TITLE : APPOINTMENT_TITLE
}))

export default compose(
  withType({ type: 'BOTRegionalDetails' }),
  connect(mapStateToProps, {
    showNewShopTiresModal,
    showAppointmentUnsupportedModal,
    showStoreLocatorModal3StepperEnabled
  }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRouter,
  withTrailerFlags,
  withHoverState,
  withNavigateToTireSearchOrShowYmme,
  withIsDesktop,
  withValuePropositionHandlers,
  withShowConfirmTireSizeModalPreconfigured,
  withConfigureHandleShopByVehicleClick,
  withRequestApptClick
)(BOTRegionalDetails)
